import { gql } from '@apollo/client'

export const ADD_NEW_CHILI_IMAGE = gql`
  mutation addNewChiliImage(
    $image: Upload!
    $groupId: String!
    $projectId: String!
  ) {
    addNewChiliImage(
      file: $image
      groupId: $groupId
      projectId: $projectId
    ) {
      id
      path
      name
      resolution
      height
      width
      xml
    }
  }
`

export const REPLACE_CHILI_IMAGE = gql`
  mutation replaceChiliImage(
    $image: Upload!
    $groupId: String!
    $projectId: String!
    $oldImageId: String
  ) {
    replaceChiliImage(
      file: $image
      groupId: $groupId
      projectId: $projectId
      oldImageId: $oldImageId
    ) {
      id
      path
      name
      resolution
      height
      width
      xml
    }
  }
`

export const DELETE_CHILI_IMAGE = gql`
  mutation deleteChiliImage($imageId: String!) {
    deleteChiliImage(imageId: $imageId)
  }
`

